import React, { useState, useEffect, useCallback, Fragment } from 'react';
import { Upload, message } from 'antd';
import useApplicationSession from '../session/UserSession';
import { getUser, updateProfile } from '../api';
import { EditOutlined } from '@ant-design/icons';

const ProfileImage = ({ allowedEdit }) => {
    const [user, setUser] = useState(undefined);
    const [localImage, setLocalImage] = useState(undefined);
    const token = useApplicationSession();

    const loadUser = useCallback(() => {
        if (token) {
            getUser({ token })
                .then((response) => {
                    setUser(response.data);
                })
                .catch((error) => {});
        }
    }, [token, setUser]);

    useEffect(() => {
        loadUser();
    }, [loadUser]);

    const uploadAvatar = (file) => {
        const hide = message.loading('Uploading image...');
        const form = new FormData();
        form.append('_method', 'PUT');
        form.append('avatar', file);
        updateProfile({ token: token, request: form })
            .then((response) => {
                hide();
                message.success(response?.message);
            })
            .catch((error) => {});
    };

    const getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    };

    return (
        <Fragment>
            {allowedEdit ? (
                <Upload
                    name="avatar"
                    accept="image/*"
                    showUploadList={false}
                    listType="picture-card"
                    beforeUpload={(info) => {
                        uploadAvatar(info);
                        getBase64(info, (url) => {
                            setLocalImage(url);
                        });
                    }}
                >
                    <img src={localImage ? localImage : user?.avatar} className="profileContainerImg" alt="profile" />
                    <EditOutlined />
                </Upload>
            ) : (
                <img src={user?.avatar} className="profileContainerImg" alt="profile" />
            )}
        </Fragment>
    );
};

export default ProfileImage;
